import { isArray } from 'lodash';

export const convertOptionSelect = (arrs: any, value: string | number, text: string) => {
    if (isArray(arrs)) {
        return arrs?.map((obj: any) => ({
            id: obj._id,
            value: obj.name,
        }));
    }
    return [];
};
